import { get, invoke } from "lodash";

export const openCookieSettings = () => {
  invoke(get(window, "Cookiebot"), "show");
};
